var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVaronis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 22,
    height: 22,
    fill: "#010203"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1428 19.1855H18L23.6698 27.5044L24.7383 25.9277L20.1428 19.1855Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2042 26.6133L24.1357 28.1881L24.284 28.4057C24.3435 28.5079 24.4244 28.596 24.5211 28.664C24.6178 28.732 24.7281 28.7783 24.8444 28.7997C24.9607 28.8211 25.0803 28.8171 25.1949 28.788C25.3095 28.7588 25.4164 28.7053 25.5084 28.6309C25.6105 28.5716 25.6985 28.4911 25.7667 28.3948C25.8349 28.2985 25.8817 28.1887 25.9037 28.0728C25.9258 27.9569 25.9227 27.8376 25.8947 27.723C25.8667 27.6083 25.8144 27.5011 25.7414 27.4084L25.2042 26.6133Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2435 19.1855H22.1007L25.7144 24.4895L26.7848 22.9128L24.2435 19.1855Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.846 27.4057L27.2412 23.5957L26.1727 25.1706L28.3848 28.403C28.517 28.5968 28.7209 28.7301 28.9514 28.7736C29.1819 28.8171 29.4203 28.7672 29.614 28.635C29.8078 28.5027 29.9411 28.2989 29.9846 28.0684C30.0281 27.8379 29.9783 27.5995 29.846 27.4057Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaronis);
export default __webpack_public_path__ + "static/media/Varonis.0cf84b36b952f9772a35bd2a12af749b.svg";
export { ForwardRef as ReactComponent };